<template>
  <el-dialog
    class="theme-dialog dialog-center dialog-body-0"
    title="题目绑定"
    width="770px"
    top="0"
    :center="true"
    :close-on-click-modal="false"
    :visible.sync="visibility"
  >
    <div class="w-full pt-6 box-border flex" style="height: 570px">
      <div class="w-1/2 h-full flex flex-col border-r border-solid border-border-gray">
        <header class="px-6 text-medium-x text-theme-black-850 leading-22 font-semibold">
          待分组题目
        </header>
        <div class="w-full mt-4 px-6 box-border">
          <el-input v-model="sKey" placeholder="搜索">
            <i
              slot="append"
              class="el-icon-search text-medium-x text-icon-default cursor-pointer"
              @click="searchHandle"
            ></i>
          </el-input>
        </div>
        <ul class="mt-4 flex-1 overflow-auto" v-if="questionList.length > 0">
          <li
            v-for="qs of questionList"
            :key="qs.id"
            class="w-full h-8 pl-6 pr-4 box-border text-medium text-theme-black-850 leading-8 truncate select-none cursor-pointer"
            :draggable="true"
            @dragstart="dragstartHandle(qs, $event)"
          >
            {{qs.orderIndex}}.{{qs.title || '—'}}
          </li>
        </ul>
        <div
          class="mt-4 flex-1 overflow-hidden text-center text-medium text-theme-black-850 leading-22"
          v-else
        >
          暂无数据
        </div>
      </div>
      <div class="w-1/2 h-full overflow-auto">
        <header class="px-6 flex items-center justify-between">
          <span class="text-medium-x text-theme-black-850 leading-22 font-semibold">
            维度管理
          </span>
          <el-button type="text" size="small" icon="el-icon-plus" @click="addDimensionHandle">
            添加维度
          </el-button>
        </header>
        <!-- v-for="(dm, dmIndex) of dmList" -->
        <section
          class="w-full mt-4 pl-6 pr-4 box-border"
          v-for="dm of dmList"
          :key="dm.id"
        >
          <!-- 标题 -->
          <div
            class="mb-2 flex items-start justify-between overflow-hidden"
            v-if="!dm.edit"
          >
            <div class="mr-6 flex-1 text-medium text-theme-black-850 leading-22 truncate-2">
              {{dm.name || '—'}}
            </div>
            <div class="flex items-center mt-1">
              <i
                class="el-icon-edit text-medium-x mr-2 cursor-pointer"
                @click="editDimensionHandle(dm)"
              ></i>
              <i
                class="el-icon-delete text-medium-x mr-1 cursor-pointer"
                @click="removeDimensionHandle(dm)"
              ></i>
              <!-- <el-dropdown @command="moveDMHandle(dmIndex, $event)">
                <i class="el-icon-more text-medium-x transform rotate-90 cursor-pointer"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="up" :disabled="dmIndex === 0">
                    上移
                  </el-dropdown-item>
                  <el-dropdown-item command="down" :disabled="dmIndex === dmList.length - 1">
                    下移
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </div>
          </div>
          <!-- 题目编辑 -->
          <el-input
            v-model="dm.name"
            placeholder="请输入"
            class="mb-2"
            :maxlength="30"
            @blur="blurDMFieldHandle(dm)"
            v-else
          />
          <!-- 有数据 -->
          <div
            class="box_area py-1 border border-dashed border-border-gray overflow-auto"
            @dragover.prevent
            @drop="dropHandle(dm, $event)"
            v-if="(dm.list || []).length > 0"
          >
            <div
              v-for="qs of (dm.list || [])"
              :key="qs.id"
              class="w-full px-4 py-1 box-border flex items-center justify-between"
            >
              <p class="flex-1 mr-5.5 leading-22">{{getDMQSIndex(qs)}}.{{qs.title || '—'}}</p>
              <i
                class="el-icon-circle-close text-medium-x cursor-pointer"
                @click.stop="removeQSItemHandle(dm, qs)"
              ></i>
            </div>
          </div>
          <!-- 无数据 -->
          <div
            class="box_area py-1 border border-dashed border-border-gray overflow-hidden"
            @dragover.prevent
            @drop="dropHandle(dm, $event)"
            v-else
          >
            <p class="w-full h-full flex justify-center items-center text-small text-theme-black-250 leading-22">
              将左边的选项拖拽到此区域
            </p>
          </div>
        </section>
      </div>
    </div>
    <template #footer>
      <footer class="text-right">
        <el-button class="normal-button" size="small" @click="cancelHandle">取消</el-button>
        <el-button
          class="normal-button"
          size="small"
          type="primary"
          :loading="bindLoading"
          @click="confirmHandle"
        >确定</el-button>
      </footer>
    </template>
  </el-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog'
import {
  getAllQuestion,
  bindTopic,
  unbindTopic,
  addDimension,
  editDimension,
  removeDimension,
} from '@/api/wenjuan/dimensionScore'
import { rejects } from 'assert'

export default {
  name: 'TopicBindDialog',
  mixins: [dialogMixins],
  props: {
    questions: {
      type: Array,
      default: () => []
    },
    dimensions: {
      type: Array,
      default: () => []
    },
    onSuccess: {
      type: [Function, null],
      default: null
    },
  },
  data() {
    return {
      sKey: '',
      searchKey: '',
      // 左侧list
      qsList: [],
      // 右侧维度list
      dmList: [],
      bindLoading: false,
      removeList: [],
      unbindList: [],
    }
  },
  computed: {
    questionList() {
      const existByDmList = this.dmList.map(m => m.list || []).flat().map(m => m.id);
      return this.qsList.filter(
        f => !existByDmList.includes(f.id) && f.title.includes(this.searchKey)
      );
    }
  },
  watch: {
    visibility(bool) {
      if (bool) {
        this.initDimensions();
      } else {
        this.sKey = '';
        this.searchKey = '';
        this.removeList.splice(0);
        this.unbindList.splice(0);
      }
    },
    questions: {
      handler(list) {
        const questionList = JSON.parse(JSON.stringify(list));
        this.setQuestionList(questionList);
      },
      deep: true,
    }
  },
  mounted() {
    if (this.questions.length > 0) {
      const questionList = JSON.parse(JSON.stringify(this.questions));
      this.setQuestionList(questionList);
    } else {
      this.getQSList();
    }
    this.initDimensions();
  },
  methods: {
    // 获取各维度下的序号
    getDMQSIndex(qsItem) {
      if (qsItem.orderIndex === null) {
        const { orderIndex = '' } = this.qsList.find(f => f.id === qsItem.id) || { orderIndex: '' };
        return orderIndex;
      }
      return qsItem.orderIndex;
    },
    // 设置初始维度表
    initDimensions() {
      const cloneDM = JSON.parse(JSON.stringify(this.dimensions));
      this.dmList = cloneDM.map((m, i) => {
        const list = (m.questions || []).map((mm, mi) => ({
          id: mm.id ?? Date.now() + i * 1000 + mi * 100,
          title: mm.content?.text ?? '',
          score: mm.answerScore?.totalScore ?? 0,
          orderIndex: null,
          origin: true
        }));
        return {
          id: `init_${Date.now() + i * 1000}`,
          name: m.name,
          originName: m.name,
          edit: false,
          list
        }
      });
    },
    // 整理设置所有考试题目
    setQuestionList(list = []) {
      this.qsList = list.map((m, index) => ({
        id: m.id,
        title: m.content?.text ?? '',
        score: m.answerScore?.totalScore ?? 0,
        orderIndex: [undefined, null, ''].includes(m.orderIndex) ? index + 1 : m.orderIndex,
      }));
    },
    // 获取左侧所有考试题目
    getQSList() {
      if (this.questions.length === 0) {
        this.qsLoading = true;
        getAllQuestion().then((res) => {
          const list = res.data.data || [];
          this.setQuestionList(list);
        }).catch(() => {
          this.$message.error('获取问卷问题列表失败');
        }).finally(() => {
          this.qsLoading = false;
        });
      }
    },
    // 获取维度命名
    getDimensionName() {
      const dms = this.dmList.filter(f => typeof f.name === 'string' && /维度\d/.test(f.name))
        .map(m => +m.name.replace(/\D/g, ''));
      if (dms.length === 0) {
        return '维度1';
      } else {
        let newNum = Math.max(...dms) + 1;
        let chNum = 1;
        for(;;) {
          if (chNum === newNum) {
            break;
          }
          const isExist = dms.includes(chNum);
          if (!isExist) {
            newNum = chNum;
            break;
          } else {
            chNum++;
          }
        }
        return `维度${newNum}`;
      }
    },
    // 添加维度
    addDimensionHandle() {
      const name = this.getDimensionName();
      const id = `${Date.now()}`;
      const data = {
        id,
        name,
        originName: name,
        edit: false,
        list: []
      };
      const rmIndex = this.removeList.findIndex(f => f === name);
      if (rmIndex > -1) {
        this.removeList.splice(rmIndex, 1);
        data.id = `init_${id}`;
      }
      this.dmList.push(data);
    },
    // 删除维度
    removeDimensionHandle(dmItem) {
      this.$confirm('点击确认，该维度不可恢复，绑定的题目也将清空，您确定要删除吗？', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (dmItem.id.startsWith('init')) {
          this.removeList.push(dmItem.originName);
          const ubList = (dmItem.list || []).map(m => ({ name: dmItem.originName, qsId: m.id }));
          this.unbindList.push(...ubList);
        }
        const index = this.dmList.findIndex(f => f.id === dmItem.id);
        this.dmList.splice(index, 1);
      }).catch(() => {});
    },
    // 编辑维度
    editDimensionHandle(dmItem) {
      dmItem.edit = true;
    },
    // 编辑框失去焦点
    blurDMFieldHandle(dmItem) {
      dmItem.edit = false;
    },
    // 上下移动
    moveDMHandle(index, moveType) {
      const [moveItem] = this.dmList.splice(index, 1);
      if (moveType === 'up') {
        this.dmList.splice(index - 1, 0, moveItem);
      } else if (moveType === 'down') {
        this.dmList.splice(index + 1, 0, moveItem);
      }
    },
    // 拖拽事件
    dragstartHandle(qsItem, e) {
      e.dataTransfer.setData('dragQS', JSON.stringify(qsItem));
    },
    dropHandle(dmItem, e) {
      const dataJSON = e.dataTransfer.getData('dragQS');
      const data = JSON.parse(dataJSON);
      const unBindIndex = this.unbindList.findIndex(s => s.qsId === data.id);
      if (unBindIndex > -1) {
        const unBindDMName = this.unbindList[unBindIndex].name;
        if (unBindDMName === dmItem.originName) {
          this.unbindList.splice(unBindIndex, 1);
        }
      }
      if (Array.isArray(dmItem.list)) {
        dmItem.list.push(data);
      } else {
        this.$set(dmItem, 'list', [data]);
      }
    },
    // 移除维度中的问卷问题
    removeQSItemHandle(dmItem, qsItem) {
      if (Array.isArray(dmItem.list)) {
        if (dmItem.id.startsWith('init') && qsItem.origin) {
          this.unbindList.push({ name: dmItem.originName, qsId: qsItem.id });
        }
        const index = dmItem.list.findIndex(f => f.id === qsItem.id);
        dmItem.list.splice(index, 1);
      }
    },
    // 左侧搜索
    searchHandle() {
      this.searchKey = this.sKey;
    },
    // 取消
    cancelHandle() {
      this.visibility = false;
    },
    // 检查是否有重复数据
    checkRepeatValue() {
      for (const dmItem of this.dmList) {
        const alldms = this.dmList.filter(f => f.id !== dmItem.id).map(m => m.name);
        if (alldms.includes(dmItem.name)) return true;
      }
      return false;
    },
    // --------------------------多重数据处理-----------------------------
    // 维度新增
    confirmAddDM() {
      return new Promise((resolve, reject) => {
        const req = this.dmList.filter(f => !f.id.startsWith('init')).map(m => m.name.trim());
        if (req.length > 0) {
          addDimension(req).then((res) => {
            const { code } = res.data || {};
            if (code === 0) {
              resolve();
            } else {
              reject();
            }
          }).catch(() => {
            reject();
          });
        } else {
          resolve();
        }
      });
    },
    // 维度修改
    confirmEditDM() {
      return new Promise((resolve, reject) => {
        const filterList = this.dmList.filter(f => f.id.startsWith('init') && f.name !== f.originName);
        const req = Object.fromEntries(filterList.map(m => [m.originName, m.name]));
        if (filterList.length > 0) {
          editDimension(req).then((res) => {
            const { code } = res.data || {};
            if (code === 0) {
              resolve();
            } else {
              reject();
            }
          }).catch(() => {
            reject();
          });
        } else {
          resolve();
        }
      });
    },
    // 维度删除
    confirmDelDM() {
      return new Promise((resolve, reject) => {
        if (this.removeList.length > 0) {
          removeDimension(this.removeList).then((res) => {
            const { code } = res.data || {};
            if (code === 0) {
              resolve();
            } else {
              reject();
            }
          }).catch(() => {
            reject();
          });
        } else {
          resolve();
        }
      });
    },
    // 题目绑定
    confirmTopicBind() {
      return new Promise((resolve, reject) => {
        const req = Object.fromEntries(
          this.dmList.map(m => [m.name, m.list.map(ml => ml.id)])
        );
        bindTopic(req).then((res) => {
          const { code, msg } = res.data || {};
          if (code === 0) {
            resolve();
          } else {
            reject();
          }
        }).catch(() => {
          reject();
        })
      });
    },
    // 题目解绑
    confirmTopicUnbind() {
      return new Promise((resolve, reject) => {
        if (this.unbindList.length > 0) {
          const req = {};
          for (const ub of this.unbindList) {
            if (ub.name in req) {
              req[ub.name].push(ub.qsId);
            } else {
              req[ub.name] = [ub.qsId];
            }
          }
          unbindTopic(req).then((res) => {
            const { code, msg } = res.data || {};
            if (code === 0) {
              resolve();
            } else {
              reject();
            }
          }).catch(() => {
            reject();
          })
        } else {
          resolve();
        }
      });
    },
    // 最终确认
    async confirmHandle() {
      const isRepeat = this.checkRepeatValue();
      if (isRepeat) {
        this.$message.warning('维度名称重复');
        return;
      }
      // 执行顺序依次是 题目解绑 -> 维度删除 -> 维度编辑 -> 维度新增 -> 题目绑定
      this.bindLoading = true;
      try {
        await this.confirmTopicUnbind();
      } catch (e) {
        this.$message.error('题目解绑失败');
        this.bindLoading = false;
        return;
      }
      try {
        await this.confirmDelDM();
      } catch (e) {
        this.$message.error('删除维度失败');
        this.bindLoading = false;
        return;
      }
      try {
        await this.confirmEditDM();
      } catch (e) {
        this.$message.error('编辑维度失败');
        this.bindLoading = false;
        return;
      }
      try {
        await this.confirmAddDM();
      } catch (e) {
        this.$message.error('新增维度失败');
        this.bindLoading = false;
        return;
      }
      for (const dm of this.dmList) {
        dm.originName = dm.name;
      }
      try {
        await this.confirmTopicBind();
        // this.$message.success('题目绑定成功');
        this.cancelHandle();
        const params = { dimensions: this.dmList };
        if (typeof this.onSuccess === 'function') {
          this.onSuccess(params);
        } else {
          this.$emit('success', params);
        }
      } catch (e) {
        this.$message.error('题目绑定失败');
      } finally {
        this.bindLoading = false;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.box_area {
  width: 100%;
  height: 109px;
}
</style>